var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#0a92ca",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 122.88",
    style: {
      enableBackground: "new 0 0 122.88 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.44,0c33.93,0,61.44,27.51,61.44,61.44c0,33.93-27.51,61.44-61.44,61.44S0,95.37,0,61.44 C0,27.51,27.51,0,61.44,0L61.44,0z M43.91,38.89h25.34c5.52,0,9.65,1.31,12.4,3.94c2.74,2.63,4.12,6.37,4.12,11.22 c0,4.98-1.5,8.88-4.5,11.68c-3,2.81-7.58,4.21-13.72,4.21H59.2v18.25H43.91V38.89L43.91,38.89z M59.2,59.96h3.75 c2.96,0,5.04-0.52,6.23-1.54c1.19-1.02,1.79-2.33,1.79-3.92c0-1.55-0.52-2.86-1.56-3.94c-1.03-1.08-2.99-1.62-5.85-1.62H59.2V59.96 L59.2,59.96z M61.44,13.92c26.24,0,47.52,21.27,47.52,47.52s-21.27,47.52-47.52,47.52c-26.24,0-47.52-21.27-47.52-47.52 S35.2,13.92,61.44,13.92L61.44,13.92z M61.44,5.41c30.94,0,56.03,25.08,56.03,56.03s-25.08,56.03-56.03,56.03 S5.41,92.38,5.41,61.44S30.5,5.41,61.44,5.41L61.44,5.41z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.777f61836c5de93be40af8155698cb8e.svg";
export { ForwardRef as ReactComponent };